/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantOnboardingCheckService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantOnboardingCheckCheckParticipantOnboardingStatus(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-onboarding-check/check-participant-onboarding-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
